import { Flex, Image, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {
  primaryAlt,
  textPrimary,
  textSecondary,
  white,
} from "../../utils/colors";
import noServices from "../../assets/images/empty-box.png";

const UserNoAccess = ({ pageName, p }) => {
  const { t } = useTranslation();

  return (
    <>
      <Flex align="center" justify="center" w="100%" p={p ? p : "10rem 0 0"}>
        <Flex
          w="100%"
          align="center"
          justify="center"
          // pl="100px"
          direction="column"
          maxW="600px"
          p="3rem 1.5rem"
          borderRadius="1.5rem"
          bg={white}
        >
          <Image h="3.5rem" w="auto" m="0rem 0 0" src={noServices} />
          <Text
            color={textPrimary}
            fontSize="1.75rem"
            fontWeight="700"
            m="1.5rem 0 0.5rem"
            textAlign="center"
          >
            {t("noAccess.title")}
          </Text>
          <Text
            color={textSecondary}
            fontSize="md"
            fontWeight="500"
            textAlign="center"
          >
            {t("noAccess.textFirst")}{" "}
            <Text as="span" color={primaryAlt}>
              "{pageName}"
            </Text>
            . {t("noAccess.textSecond")}{" "}
          </Text>
        </Flex>
      </Flex>
    </>
  );
};

export default UserNoAccess;
